import React, { useContext, useEffect, useState } from 'react';
import { ClientContext } from '../../../contexts/clientProvider';
import DetailsModal from './Details';
import BaseButton from '../../General/FormsComp/Button/BaseButton';

const Moviments = ({ closeModal, month, ano, data }) => {
    const [movedClients, setMovedClients] = useState([]);
    const [showDetails, setShowDetails] = useState('');
    const { clientes, getPatsDetails } = useContext(ClientContext);


    useEffect(() => {
        adjustAndGetData();
    }, [data]);

    const adjustAndGetData = async () => {
        let patsNFS = data.map((item) => item.id_patrimonioNFS).filter(i => i !== null);
        let pats = data.map((item) => item.id_patrimonio).filter(i => i !== null);

        let detailedPats = await getPatsDetails(pats, patsNFS);

        let movesDetails = [...data]?.map((item) => {
            let detailedPat = detailedPats.find((pat) => pat.patrimonio_id === item.id_patrimonio || pat.patrimonio_id === item.id_patrimonioNFS);
            if (detailedPat) {
                item.ramal = detailedPat.ramal;
                item.marca = detailedPat.marca;
                item.modelo = detailedPat.modelo;
                item.etiqueta = detailedPat.nEtiqueta;
                item.nome_anexo_anterior = item.movimento_anterior?.nome_anexo_anterior;
            }
            return item;
        })
        const clientsChanges = [...clientes].map((client) => {
            let clientsMoves = movesDetails.filter((item) => item.id_cliente === client.id);
            return {
                ...client,
                moves: clientsMoves
            }
        });
        const clientsFiltered = clientsChanges.filter((client) => client.moves.length > 0 && !client.tem_contrato_global);
        const clientsSorted = clientsFiltered.sort((a, b) => a.nome.localeCompare(b.nome));
        setMovedClients(clientsSorted);
    }



    const hasZero = (month) => month < 10 ? "0" + month : month;




    return (
        <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-120 p-4'>
            {showDetails && (<DetailsModal
                client={movedClients.find(client => client.id === showDetails)}
                closeDetailsModal={() => setShowDetails('')}
                month={hasZero(month)}
                ano={ano}
            />
            )}
            <div className='bg-white dark:bg-gray-800 rounded-3xl shadow-vox-2xl max-w-6xl w-full mx-4 max-h-[90vh] overflow-hidden flex flex-col'>
                <div className='absolute top-4 right-4 z-10'>
                    <button 
                        onClick={() => closeModal()} 
                        className='p-2 text-gray-500 hover:text-red-500 dark:text-gray-400 dark:hover:text-red-400 transition-colors duration-200'
                    >
                        <span className='text-3xl'>&times;</span>
                    </button>
                </div>
                <div className='bg-gradient-to-r from-vox-blue-600 to-vox-blue-800 px-6 py-6'>
                    <h1 className='text-2xl font-bold text-white mb-4'>
                        <strong>Data:</strong> {hasZero(month)}/{ano}
                    </h1>
                </div>
                <div className='flex-1 overflow-y-auto p-6'>
                    <div className='mb-8'>
                        <h2 className='text-xl font-semibold text-gray-800 dark:text-white mb-4'>Clientes Movimentados</h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                            {
                                movedClients.length > 0 ? movedClients.map((client) => (
                                    <div 
                                        key={client.id} 
                                        className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-700 rounded-lg p-3 cursor-pointer hover:bg-blue-100 dark:hover:bg-blue-900/30 transition-colors duration-200"
                                        onClick={() => setShowDetails(client.id)}
                                    >
                                        <span className="text-blue-800 dark:text-blue-200 font-medium">{client.nome}</span>
                                    </div>
                                )) : (
                                    <div className="col-span-full">
                                        <h3 className="text-gray-600 dark:text-gray-400 font-medium">
                                            <strong>Nenhum cliente movido</strong>
                                        </h3>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                    
                    <div>
                        <h2 className='text-xl font-semibold text-gray-800 dark:text-white mb-4'>Todos Detalhes</h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                            {
                                data.map((item) => (
                                    <div
                                        key={item.id}
                                        className='bg-white dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow duration-200'
                                    >
                                        <div className='mb-3'>
                                            <h3 className='text-lg font-semibold text-gray-800 dark:text-white mb-2'>
                                                <strong>Patrimônio:</strong> {item.nEtiqueta || item.etiqueta || 'N/A'}
                                            </h3>
                                        </div>
                                        
                                        <div className='space-y-2 text-sm'>
                                            <div className='flex justify-between'>
                                                <span className='font-medium text-gray-600 dark:text-gray-300'>Usuário:</span>
                                                <span className='text-gray-800 dark:text-white'>{item.usuario}</span>
                                            </div>
                                            
                                            <div className='flex justify-between'>
                                                <span className='font-medium text-gray-600 dark:text-gray-300'>Anexo Atual:</span>
                                                <span className='text-gray-800 dark:text-white text-right'>{item.nome_anexo_atual}</span>
                                            </div>
                                            
                                            {item.movimento_anterior && (
                                                <div className='mt-4 pt-3 border-t border-gray-200 dark:border-gray-600'>
                                                    <h4 className='font-semibold text-gray-700 dark:text-gray-300 mb-2'>Movimento Anterior:</h4>
                                                    <div className='space-y-1 text-xs'>
                                                        <div className='flex justify-between'>
                                                            <span className='text-gray-500 dark:text-gray-400'>ID:</span>
                                                            <span className='text-gray-700 dark:text-gray-300'>{item.movimento_anterior.id}</span>
                                                        </div>
                                                        <div className='flex justify-between'>
                                                            <span className='text-gray-500 dark:text-gray-400'>Usuário:</span>
                                                            <span className='text-gray-700 dark:text-gray-300'>{item.movimento_anterior.usuario}</span>
                                                        </div>
                                                        <div className='flex justify-between'>
                                                            <span className='text-gray-500 dark:text-gray-400'>Anexo Anterior:</span>
                                                            <span className='text-gray-700 dark:text-gray-300 text-right'>{item.movimento_anterior.nome_anexo_anterior}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ))}
                        </div>
                    </div>
                </div>
                <div className="p-6 border-t border-gray-200 dark:border-gray-700 flex justify-end">
                    <BaseButton
                        onClick={closeModal}
                        variant="primary"
                        size="md"
                    >
                        Fechar
                    </BaseButton>
                </div>
            </div>
        </div>
    );
};

export default Moviments;
